import { RoleProvider } from 'contexts/role.context';
import React, { FC, ReactNode } from 'react';

const RoleLayout: FC<{ children: ReactNode }> = ({ children }) => {
  return <RoleProvider>{children}</RoleProvider>;
};

export default RoleLayout;
